/**
 * @file LoadWhenNeeded.js
 */
'use strict';

/**
 * 初期表示を優先するため、画面外の画像などは次のどちらか早い方で読み込む。
 * - 要素が画面に入った時（ページ読み込み完了前にスクロールされた場合）
 * - ページの読み込み完了後（load）
 *
 * @param {Element} element - 監視する要素
 * @param {Function} callback - 読み込み処理（1回だけ実行）
 * @return undefined
 */
export default function loadWhenNeeded(element, callback) {
	let isDone = false;
	let observer = null;
	const run = () => {
		if (isDone) return;
		isDone = true;
		if (observer) observer.disconnect();
		window.removeEventListener('load', run);
		callback();
	};

	if (!element || !('IntersectionObserver' in window)) {
		run();
		return;
	}

	observer = new IntersectionObserver((entries) => {
		if (entries.some((entry) => entry.isIntersecting)) run();
	});
	observer.observe(element);

	if (document.readyState === 'complete') {
		run();
	} else {
		window.addEventListener('load', run);
	}
}
